import { render } from "./TableComponent.vue?vue&type=template&id=5c2d62c6&scoped=true&ts=true"
import script from "./TableComponent.vue?vue&type=script&lang=ts"
export * from "./TableComponent.vue?vue&type=script&lang=ts"

import "./TableComponent.vue?vue&type=style&index=0&id=5c2d62c6&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2d62c6"]])

export default __exports__